import ky from "ky"
import { afterHooks } from "./http/hooks"

const authClient = ky.extend({
  throwHttpErrors: true,
  retry: 2,
  prefixUrl: "/auth/h3login",
  hooks: {
    afterResponse: [afterHooks.handleEmptyResponse, afterHooks.handleErrors],
  },
})

export type TokensPayload = {
  username: string
  password: string
}

type TokensResponse = {
  access_token: string
  expires_in: number
  jti: string
  refresh_token: string
  scope: string
  token_type: string
}

export type Tokens = {
  accessToken: string
  refreshToken?: string
}

function makeTokensResponse(res: any) {
  const { access_token, refresh_token } = res as TokensResponse
  return {
    accessToken: access_token,
    refreshToken: refresh_token,
  }
}

export const getTokens = (values: TokensPayload) => {
  const searchParams = new URLSearchParams()
  searchParams.set("client_id", "login")
  searchParams.set("grant_type", "password")
  searchParams.set("username", values.username)
  searchParams.set("password", values.password)

  return authClient
    .post("token", {
      body: searchParams,
    })
    .json()
    .then(makeTokensResponse)
}

export const getRefreshTokens = (refreshToken: string) => {
  const searchParams = new URLSearchParams()
  searchParams.set("grant_type", "refresh_token")
  searchParams.set("client_id", "login")
  searchParams.set("refresh_token", refreshToken)
  return authClient
    .post("token", {
      body: searchParams,
    })
    .json()
    .then(makeTokensResponse)
}

export const getTokenFromCode = (code: string) => {
  const searchParams = new URLSearchParams()
  searchParams.set("client_id", "login")
  searchParams.set("grant_type", "authorization_code")
  searchParams.set("code", code)
  searchParams.set("redirect_uri", `${window.location.origin}/api/login`)
  return authClient
    .post("token", { body: searchParams })
    .json()
    .then(makeTokensResponse)
}
